module.exports = __webpack_public_path__ + "static/media/iaas.97ac7084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/iaas.svg
// module id = 1105
// module chunks = 49